import { render, staticRenderFns } from "./WS-Header.vue?vue&type=template&id=1243dd0a"
import script from "./WS-Header.vue?vue&type=script&lang=js"
export * from "./WS-Header.vue?vue&type=script&lang=js"
import style0 from "./WS-Header.vue?vue&type=style&index=0&id=1243dd0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports